export default __webpack_public_path__ + "static/media/Rune Stone of the Eiglophians.22ea3279.jpg";